import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { apiProtocolDetail } from '@/service/api'
import { sanitizeHTML } from '@/utils'

const Protocol = () => {
  const [data, setData] = useState<any>(null)
  const { search } = useLocation();
  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const id = searchParams.get('id');
    if (id) {
      apiProtocolDetail({ protocolId: id }).then((res) => {
        setData({
          title: decodeURIComponent(res.data.title),
          content: sanitizeHTML(decodeURIComponent(res.data.content))
        });
      });
    }
  }, [])
  return (
    <div className='bg-white min-h-screen leading-[1.5]'>
      <div className='max-w-8xl px-10 mx-auto flex flex-col items-center pt-10'>
        <span className='text-center text-[28px] mb-10'>{data?.title}</span>
        <div dangerouslySetInnerHTML={{ __html: data?.content }} className='w-full'>

        </div>
      </div>
    </div>

  )
}

export default Protocol